export default {
  site: {
    separator: ' | ',
    mnbaq: 'MNBAQ',
    resources: 'Ressources pédagogiques', // traduire
    mnbaqFull: 'Musée national des beaux-arts du Québec', // traduire
  },

  titles: {
    home: 'Home page',
    notFound: 'Page not found',
  },

  home: {
    title: 'Home',
    inspiration: 'Find inspiration',
    featured: 'Featured content',
    search: {
      explore: 'or explore by'
    },
  },

  activities: {
    title: 'Activities',
  },

  artworks: {
    title: 'Artworks',
  },

  resources: {
    title: 'Resources',
  },

  search: {
    title: 'Search',
  },
  lexique: {
    title: 'Lexique',
  },
  landing: {
    orSearch: 'or start a new search',
    favorites: 'Favorites',
    seeAll: {
      activity: 'See all activities',
      artwork: 'See all artworks',
      resource: 'See all resources',
    },
  },

  // Secondary Nav
  mnbaq: {
    title: 'mnbaq.org',
  },
  visit: {
    title: 'Visit the museum',
  },

  // Activity
  activity: {
    title: 'Activity',
    duration: 'Duration',
    evaluationGrid: 'Evaluation grid',
    inspiredBy: 'Inspired by',
    isRecommended: 'Activity recommended!',
    material: 'Material',
    otherActivities: {
      title: 'Keep exploring!',
      description: '',
    },
    shareActivity: 'Share this activity',
    steps: 'Steps',
    recommendedCount: 'Recommended {n} times',
    recommendThis: 'Recommend this activity',
    resourcesHeader: {
      title: 'To guide you!',
      description: 'Resources associated with this {n}'
    },
    schoolLevel: 'School level(s)',
  },

  // Artwork
  artwork: {
    title: 'Artwork',
    dimensions: 'Dimensions',
    expressionTechniques: 'Expression techniques',
    linkedActivities: {
      title: 'Your turn to shine!',
      description: 'Activities associated with this {n}',
      descriptionSingular: 'Activity associated with this {n}',
    },
    otherArtworks: {
      title: 'Discover other artworks',
      description: '',
    },
    productionDate: 'Production date',
    resourcesHeader: {
      title: 'Keep exploring!',
      description: 'Resources associated with this {n}'
    },
  },

  // Resource
  resource: {
    title: 'Resource',
  },

  // Cards
  cards: {
    activityCount: {
      singular: '{count} activity',
      plural: '{count} activities',
    },
  },

  // General
  share: 'Share',
  print: 'Print',
  copiedUrl: 'Link copied!',
  loading: 'Loading',

  single: {
    about: 'About {n}',
    contentType: {
      activity: 'activity',
      artwork: 'artwork',
    },
    resources: {
      videos: 'Videos',
      files: 'Downloadable files',
    },
    suggestions: 'Sugestions',
    suggestionsLinks: 'Interesting links',
    suggestionsMedias: 'Medias',
  },

  // Not Found (404)
  notFound: {
    returnToHome: 'Return to homepage',
  },

  // Temporaire
  formDemo: {
    title: 'Demo',
  },

  uiKit: {
    title: 'UI Kit',
  },

};



// WEBPACK FOOTER //
// ./src/config/locales/en/pages.js